// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"c0da73fa","453":"cbd41c82"}[chunkId] + ".chunk.js";
};